module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAMAAAAi2JHqAAAAQlBMVEUAAAAoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKChH2iaEAAAAFXRSTlMADGtlJHDjIN/B5cbDvmGX+9t8Nx1ZHj0bAAAAUklEQVQoz83JSRKAIAxE0RBEHMGp739VL9BaRSUL/vJ9YZWLcsIRKKM0cTSzOrGaOTpxMvPNWSrOwPyZsNKRXcfWOMaPMfyMucOxYPcbKnTULC8/gwdg+r7xMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanhui.png
// module id = CuwH
// module chunks = 1